module.exports = __webpack_public_path__ + "img/oxford-logo.20ce63a6.jpg";